import compareAsc from "../compareAsc/index.mjs";
import add from "../add/index.mjs";
import differenceInDays from "../differenceInDays/index.mjs";
import differenceInHours from "../differenceInHours/index.mjs";
import differenceInMinutes from "../differenceInMinutes/index.mjs";
import differenceInMonths from "../differenceInMonths/index.mjs";
import differenceInSeconds from "../differenceInSeconds/index.mjs";
import differenceInYears from "../differenceInYears/index.mjs";
import toDate from "../toDate/index.mjs";
import requiredArgs from "../_lib/requiredArgs/index.mjs";
function intervalToDuration(interval) {
  requiredArgs(1, arguments);
  var start = toDate(interval.start);
  var end = toDate(interval.end);
  if (isNaN(start.getTime())) throw new RangeError("Start Date is invalid");
  if (isNaN(end.getTime())) throw new RangeError("End Date is invalid");
  var duration = {};
  duration.years = Math.abs(differenceInYears(end, start));
  var sign = compareAsc(end, start);
  var remainingMonths = add(start, {
    years: sign * duration.years
  });
  duration.months = Math.abs(differenceInMonths(end, remainingMonths));
  var remainingDays = add(remainingMonths, {
    months: sign * duration.months
  });
  duration.days = Math.abs(differenceInDays(end, remainingDays));
  var remainingHours = add(remainingDays, {
    days: sign * duration.days
  });
  duration.hours = Math.abs(differenceInHours(end, remainingHours));
  var remainingMinutes = add(remainingHours, {
    hours: sign * duration.hours
  });
  duration.minutes = Math.abs(differenceInMinutes(end, remainingMinutes));
  var remainingSeconds = add(remainingMinutes, {
    minutes: sign * duration.minutes
  });
  duration.seconds = Math.abs(differenceInSeconds(end, remainingSeconds));
  return duration;
}
export {
  intervalToDuration as default
};
